var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "float-right boss-batch-select" }, [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedTargetOption,
            expression: "selectedTargetOption",
          },
        ],
        staticClass: "boss-input-select",
        on: {
          change: function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.selectedTargetOption = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
        },
      },
      _vm._l(_vm.targetOptions, function (targetOption, i) {
        return _c(
          "option",
          {
            key: i,
            attrs: { "data-test": "target-option-" + targetOption.key },
            domProps: { value: targetOption },
          },
          [_vm._v("\n      " + _vm._s(targetOption.optionLabel) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: {
              content: _vm.showTooltip
                ? "一括操作は1回あたり2,000件以内です。"
                : "",
            },
            expression:
              "{content: showTooltip ? '一括操作は1回あたり2,000件以内です。':''}",
          },
        ],
      },
      [
        _c(
          "button",
          {
            staticClass: "boss-button boss-exe-button pega-button",
            attrs: { disabled: _vm.isDisabled, "data-test": "action-button" },
            on: {
              click: function ($event) {
                return _vm.doAction()
              },
            },
          },
          [
            _c("span", { staticClass: "boss-exe-button-text" }, [
              _vm._v("\n        実行する\n      "),
            ]),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "reveal boss-modal-container pega-modal-position",
        attrs: { id: "bulk-update-modal", "data-reveal": "" },
      },
      [
        _c(
          "h1",
          {
            staticClass:
              "boss-page-title boss-page-title-layout-title pega-mb-25",
            attrs: { "data-test": "modal-title" },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.selectedTargetOption.name) +
                "の一括更新\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "boss-layout boss-layout-center" }, [
          _c("div", { staticClass: "pega-bulk-update-container" }, [
            _vm.selectedTargetOption.key === "phase_and_status"
              ? _c("div", [
                  _c("div", { attrs: { "data-test": "modal-body-phase" } }, [
                    _vm._v(
                      "\n            選択したすべての応募者の選考フェーズ\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.phaseId,
                            expression: "phaseId",
                          },
                        ],
                        staticClass: "boss-input-select pega-mb-25",
                        attrs: { "data-test": "input-select-phase" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.phaseId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(
                        _vm.itemOptionMap.phases(),
                        function (itemOption, i) {
                          return _c(
                            "option",
                            {
                              key: i,
                              attrs: {
                                "data-test":
                                  "item-option-phase-" + itemOption.id,
                              },
                              domProps: { value: itemOption.id },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(itemOption.name) +
                                  "\n              "
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { "data-test": "modal-body-status" } }, [
                      _vm._v(
                        "\n              選択したすべての応募者の選考ステータス\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.statusId,
                              expression: "statusId",
                            },
                          ],
                          staticClass: "boss-input-select",
                          attrs: { "data-test": "input-select-status" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.statusId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        _vm._l(
                          _vm.itemOptionMap.phaseStatuses(),
                          function (itemOption, i) {
                            return _c(
                              "option",
                              {
                                key: i,
                                attrs: {
                                  "data-test":
                                    "item-option-status-" + itemOption.id,
                                },
                                domProps: { value: itemOption.id },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(itemOption.name) +
                                    "\n                "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]),
                ])
              : _c("div", [
                  _c("div", { attrs: { "data-test": "modal-body" } }, [
                    _vm._v(
                      "\n            選択したすべての応募者の" +
                        _vm._s(_vm.selectedTargetOption.name) +
                        "を\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.selectedTargetOption.key === "responsible_staffs"
                    ? _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.responsibleStaffId,
                              expression: "responsibleStaffId",
                            },
                          ],
                          staticClass: "boss-input-select",
                          attrs: {
                            "data-test": "input-select-responsible-staffs",
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.responsibleStaffId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        _vm._l(
                          _vm.itemOptionMap.responsibleStaffs(),
                          function (itemOption, i) {
                            return _c(
                              "option",
                              {
                                key: i,
                                attrs: {
                                  "data-test":
                                    "item-option-responsible-staff-" +
                                    itemOption.id,
                                },
                                domProps: { value: itemOption.id },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(itemOption.name) +
                                    "\n            "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedTargetOption.key === "remarks"
                    ? _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.remarks,
                            expression: "remarks",
                          },
                        ],
                        staticClass:
                          "boss-send-textarea pega-textarea-resize-none",
                        attrs: { "data-test": "input-textarea-remarks" },
                        domProps: { value: _vm.remarks },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.remarks = $event.target.value
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v("に")]),
                ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass:
                    "float-center boss-button-center boss-button-large pega-button pega-mr-20",
                  attrs: {
                    disabled: _vm.isSelectionDisabled,
                    type: "button",
                    "data-test": "update-button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.update()
                    },
                  },
                },
                [_vm._v("\n            更新する\n          ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass:
                    "float-center boss-button-center boss-button-large",
                  attrs: { type: "button", "data-test": "cancel-button" },
                  on: {
                    click: function ($event) {
                      return _vm.closeReveal()
                    },
                  },
                },
                [_vm._v("\n            キャンセル\n          ")]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("button", {
          staticClass: "close-button boss-close-button boss-icon-cross",
          attrs: {
            "data-close": "",
            "aria-label": "Close modal",
            type: "button",
          },
          on: {
            click: function ($event) {
              return _vm.closeReveal()
            },
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }